import Effects from 'Effects';
import Tone from 'tone';
import {PercentageValueParameter, AbstractParameter, ValueParameter} from 'parameters/AbstractParameter.js';

class AutoWahEffect extends Effects.Effect {

    constructor(sequencerEngine) {
        super('Auto Wah', () => new Tone.AutoWah(50, 6, -30), sequencerEngine); 
        this.effectNode.gain.value = 6;
        this.baseFrequencyParameter = new AbstractParameter(
            'Base Frequency', this.effectNode, (o, v) => o.baseFrequency = v, {
                min: 0,
                max: 10000,
                unit: 'hz',
                defaultValue: 400
            });
        this.registerParameter(this.baseFrequencyParameter);
        this.octaveParameter = new AbstractParameter(
            'Octaves', this.effectNode, (o, v) => o.octaves = v, {
                min: 0,
                max: 10,
                unit: '',
                defaultValue: 1
            });
        this.registerParameter(this.octaveParameter);
        this.qParameter = new ValueParameter(
            'Q', this.effectNode.Q, {
                min: 0,
                max: 10,
                unit: '',
                defaultValue: 0
            });
        this.registerParameter(this.qParameter);
        this.sensitivityParameter = new AbstractParameter(
            'Sensitivity', this.effectNode, (o, v) => o.sensitivity = v, {
                min: -12,
                max: 6,
                unit: 'db',
                defaultValue: 0
            });
        this.registerParameter(this.sensitivityParameter);
        this.attackParameter = new AbstractParameter(
            'Attack', this.effectNode, (o, v) => o.follower.attack = v, {
                min: 0,
                max: 2,
                unit: '',
                defaultValue: 0
            });
        this.registerParameter(this.attackParameter);
        this.releaseParameter = new AbstractParameter(
            'Release', this.effectNode, (o, v) => o.follower.release = v, {
                min: 0,
                max: 2,
                unit: '',
                defaultValue: 0
            });
        this.registerParameter(this.releaseParameter);
    }

    getJson() {
        let json = super.getJson();
        json.name = this.name;
        json.baseFrequency = this.baseFrequencyParameter.get();
        json.octave = this.octaveParameter.get();
        json.q = this.qParameter.get();
        json.sensitivity = this.sensitivityParameter.get();
        json.attack = this.attackParameter.get();
        json.release = this.releaseParameter.get();
        json.wet = this.wetParameter.get();
        return json;
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);
        if ('baseFrequency' in json) {
            this.baseFrequencyParameter.set(json.baseFrequency);
        }
        if ('octave' in json) {
            this.octaveParameter.set(json.octave);
        }
        if ('sensitivity' in json) {
            this.sensitivityParameter.set(json.sensitivity);
        }
        if ('q' in json) {
            this.qParameter.set(json.q);
        }
        if ('attack' in json) {
            this.attackParameter.set(json.attack);
        }
        if ('release' in json) {
            this.releaseParameter.set(json.release);
        }
        if (json.enabled) {
            this.enable(true);
        }
        if ('wet' in json) {
            this.setValue(json.wet);
        }
    }

    getEffectCopy() {
        var copy = new AutoWahEffect(this.sequencerEngine);
        copy.fromJson(this.getJson(), true);
        return copy;
    }
}

export default AutoWahEffect;
